import styles from './VideoFrame.module.css';

interface Props {
  readonly url: string;
  readonly mimeType: string;
  /** Accessible name for the player. */
  readonly title: string;
}

// Inline player for a video file we host, in the same 16:9 frame as the
// YouTube / Vimeo embed. Footage of another shape letterboxes inside it.
// `preload="metadata"` fetches only the duration and first frame until the
// viewer presses play; seeking relies on the media route's byte-range
// support.
export function HostedVideoPlayer({ url, mimeType, title }: Props) {
  return (
    <div className={styles.wrap}>
      <video
        // Browsers pick a <source> only on load(); keying by URL remounts the
        // element when client navigation swaps one resource's video for
        // another's, instead of leaving the old video playing.
        key={url}
        className={styles.frame}
        controls
        playsInline
        preload="metadata"
        aria-label={title}
      >
        <source src={url} type={mimeType} />
      </video>
    </div>
  );
}
